import { MailBoxProvider } from '@namespace/account';
import { BetSlipProvider } from '@namespace/betslip';
import {
  BottomNavigationMenuProvider,
  FixScrollProvider,
  ReferenceProvider
} from '@namespace/common';
import { CookieManagementProvider } from '@namespace/cookie-management';
import { BonusShopProvider, ClubProvider } from '@namespace/loyalty';
import { NotificationProvider } from '@namespace/notifications';
import { PaymentsProvider } from '@namespace/payments';
import { PredictionsProvider } from '@namespace/predictions';
import { TelegramAppProvider } from '@namespace/telegram-app';
import { CoefTypeProvider } from '@namespace/user';
import { WidgetLayoutProvider } from '@namespace/widget';

export const appProvidersMap = {
  betsType: CoefTypeProvider,
  fixScroll: FixScrollProvider,
  reference: ReferenceProvider,
  notification: NotificationProvider,
  betSlip: BetSlipProvider,
  club: ClubProvider,
  mailBox: MailBoxProvider,
  predictions: PredictionsProvider,
  shop: BonusShopProvider,
  payments: PaymentsProvider,
  widgetLayoutProvider: WidgetLayoutProvider,
  cookieManagementProvider: CookieManagementProvider,
  bottomNavigationMenu: BottomNavigationMenuProvider,
  telegramAppProvider: TelegramAppProvider
};
